import React, { useEffect, useState } from 'react';
import { DatePicker, Input, Modal } from 'antd';
import dayjs from 'dayjs';
import AddressAutocomplete from '../../components/common/AddressAutocomplete';
import type { MutationStopDraft } from './types';

type Props = {
  open: boolean;
  stop: MutationStopDraft | null;
  title: string;
  onCancel: () => void;
  onSave: (stop: MutationStopDraft) => void;
};

export function MutationStopEditorModal({ open, stop, title, onCancel, onSave }: Props) {
  const [draft, setDraft] = useState<MutationStopDraft | null>(stop);

  useEffect(() => {
    setDraft(stop);
  }, [stop, open]);

  if (!draft) return null;

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      onOk={() => onSave(draft)}
      okText="Применить"
      cancelText="Отмена"
      destroyOnClose
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <AddressAutocomplete
          value={draft.address ?? ''}
          onChange={(value) => setDraft((s) => (s ? { ...s, address: value || null } : s))}
          placeholder="Адрес"
        />
        <Input
          placeholder="Город"
          value={draft.city ?? ''}
          onChange={(e) => setDraft((s) => (s ? { ...s, city: e.target.value || null } : s))}
        />
        <DatePicker
          style={{ width: '100%' }}
          format="DD.MM.YYYY"
          placeholder="Плановая дата"
          value={draft.plannedAt ? dayjs(draft.plannedAt) : null}
          onChange={(d) =>
            setDraft((s) => (s ? { ...s, plannedAt: d ? d.toISOString() : null } : s))
          }
        />
        <Input
          placeholder="Контактное лицо"
          value={draft.contactPerson ?? ''}
          onChange={(e) =>
            setDraft((s) => (s ? { ...s, contactPerson: e.target.value || null } : s))
          }
        />
        <Input
          placeholder="Телефон"
          value={draft.phone ?? ''}
          onChange={(e) => setDraft((s) => (s ? { ...s, phone: e.target.value || null } : s))}
        />
        <Input.TextArea
          placeholder="Комментарий"
          rows={3}
          value={draft.notes ?? ''}
          onChange={(e) => setDraft((s) => (s ? { ...s, notes: e.target.value || null } : s))}
        />
      </div>
    </Modal>
  );
}
